import { useGSAP } from '@gsap/react'
import React, { useRef } from 'react'
import { animateWithGsap } from '../utils/animations';
import { explore1Img, explore2Img} from '../utils';
import gsap from 'gsap';

const Features = () => {
  const videoRef = useRef();

  useGSAP(() => {
    gsap.to('#exploreVideo', {
      scrollTrigger: {
        trigger: '#exploreVideo',
        toggleActions: 'play pause reverse restart',
        start: '-10% bottom',
      },
      onComplete: () => {
        videoRef.current.play();
      }
    })

    animateWithGsap('#features_title', { y:0, opacity:1})
    animateWithGsap(
      '.g_grow',
      { scale: 1, opacity: 2, ease: 'power1' },
      { scrub: 5.5 }
    );
    animateWithGsap(
      '.g_text',
      {y:0, opacity: 1,ease: 'power2.inOut',duration: 1}
    )
  }, []);

  return (
    <section className="h-full common-padding bg-white relative overflow-hidden">
      <div className="screen-max-wdith">
        <div className="mb-12 w-full">
          <h1 id="features_title" className="section-heading text-center">Our Working Process</h1>
        </div>
        
        <div className="flex flex-col justify-center items-center overflow-hidden">
          {/* <div className="mt-32 mb-24 pl-24">
            <h2 className="text-5xl text-slate-900 lg:text-7xl font-semibold">Lorem</h2>
            <h2 className="text-5xl lg:text-7xl font-semibold text-teal-400">Forged in titanium.</h2>
          </div> */}

          <div className="flex-center flex-col sm:px-10">
            {/* <div className="relative h-[50vh] w-full flex items-center">
              <video playsInline id="exploreVideo" className="w-full h-full object-cover object-center" preload="none" muted autoPlay ref={videoRef}>
                <source src={exploreVideo} type="video/mp4" />
              </video>
            </div> */}

            <div className="flex flex-col w-full relative">
              <div className="feature-video-container">
                <div className="overflow-hidden flex-1 h-[50vh]">
                  <img src={explore1Img} alt="ali construction 1" className="feature-video g_grow" />
                </div>
                <div className="overflow-hidden flex-1 h-[50vh]">
                  <img src={explore2Img} alt="ali construction 2" className="feature-video g_grow" />
                </div>
              </div>

            <div className="feature-text-container">
  <div className="flex-1 flex flex-col gap-6">
  
    <div className="feature-boxx">
      <h3 className="feature-headingg">
        01. Consultation
      </h3>
      <p className="feature-text g_text">
        We discuss your project requirements, ideas, and goals to understand your vision.
      </p>
    </div>

    <div className="feature-boxx">
      <h3 className="feature-headingg">
        02. Planning & Design
      </h3>
      <p className="feature-text g_text">
        Our team creates a detailed plan and provides recommendations tailored to your property and budget.
      </p>
    </div>

  </div>

  <div className="flex-1 flex flex-col gap-6">

    <div className="feature-boxx">
      <h3 className="feature-headingg">
        03. Construction & Renovation
      </h3>
      <p className="feature-text g_text">
        We carry out the work with precision, professionalism, and attention to detail.
      </p>
    </div>

    <div className="feature-box">
      <h3 className="feature-headingg">
        04. Final Completion
      </h3>
      <p className="feature-text g_text">
        We complete the project to the highest standards and ensure you are fully satisfied with the results.
      </p>
    </div>

  </div>
</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Features